import type {
  ResponseArtifactDTO,
  SpendApprovalBookingState,
  SpendingApprovalArtifact,
} from '@dreamai/types';

/**
 * Spending approvals the system books itself on approval (rail today; hotels
 * and flights adopt the same marker). Keep the shared response fields while
 * narrowing so the page can continue rendering other artifact types.
 */
export const isSystemBookingArtifact = (
  artifact: ResponseArtifactDTO | null | undefined,
): artifact is ResponseArtifactDTO & SpendingApprovalArtifact =>
  artifact?.artifactType === 'spending_approval' &&
  !!(artifact as SpendingApprovalArtifact).systemBooking?.kind;

export const spendApprovalBookingState = (
  artifact: ResponseArtifactDTO | null | undefined,
): SpendApprovalBookingState | null => {
  if (!isSystemBookingArtifact(artifact)) return null;
  const booking = artifact.userResponse?.booking;
  return booking && typeof booking === 'object' && 'state' in booking
    ? booking
    : null;
};

/** Terminal states need no further polling. */
export const isSettledBookingState = (
  state: SpendApprovalBookingState | null,
): boolean =>
  state?.state === 'booked' ||
  state?.state === 'not_booked' ||
  state?.state === 'unknown';
